import { render, staticRenderFns } from "./SolicitudAdicional.vue?vue&type=template&id=f6d82424&"
import script from "./SolicitudAdicional.vue?vue&type=script&lang=js&"
export * from "./SolicitudAdicional.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudAdicional.vue?vue&type=style&index=0&id=f6d82424&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports